import {AfterViewInit, Component, OnDestroy, ViewChild} from '@angular/core';
import {CardComponent} from "../../components/ui/card/card.component";
import {MapComponent} from "../../components/ui/map/map.component";
import {ProjectService} from "../../services/project.service";
import {Subscription} from "rxjs";
import {Router} from "@angular/router";

@Component({
  selector: 'app-projects-map',
  standalone: true,
  imports: [
    CardComponent,
    MapComponent
  ],
  templateUrl: './projects-map.component.html',
  styleUrl: './projects-map.component.scss'
})
export class ProjectsMapComponent implements AfterViewInit, OnDestroy {
  @ViewChild('map') map?: MapComponent;
  subscriptions: Subscription[] = [];
  projects$ = this.projectService.locations();

  constructor(private projectService: ProjectService, private router: Router) {
  }

  ngAfterViewInit() {
    this.subscriptions.push(
      this.projects$.subscribe(projects => {
        projects
          .filter(project => project.latitude && project.longitude)
          .forEach(project => {
            this.map!.createMarker({ lat: project.latitude, lng: project.longitude }, () => {
              this.router.navigate(['panel', 'projects', 'detail', project.id]);
            });
          });
      }),
    )
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
